import { useState, useEffect } from "react";
import { setIsNewOrderToFalseUrl } from "../../api/endpoints";
import { uiAlert } from "../alerts/customAlert/uiAlert";

const EachReceiveOder = ({ order, selectedOrder, setSelectedOrder, userCurrency }) => {
  const [newOrder, setNewOrder] = useState(false);

  useEffect(() => {
    order.isNewOrder && setNewOrder(true);
  }, []);

  const handleClick = (e) => {
    setSelectedOrder(order);
    setNewOrder(false);
    order.isNewOrder && setIsNewOrderToFalse(order._id);
    /* send http request to make isNewOrder to false */
    let x = ["pending", "transit", "delivered"];
    /* updateDelStat(x[Math.floor(Math.random() * 3)]); */
  };

  const setIsNewOrderToFalse = async (orderID) => {
    try {
      let response = await fetch(setIsNewOrderToFalseUrl + orderID, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        uiAlert("ok");
      } else {
        uiAlert("not ok");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div onClick={handleClick} className={`EachRecicvedOrderDiv ${selectedOrder?._id === order._id ? "selectedReceivedItem" : ""}`}>
        {" "}
        {/* selectedReceivedItem */}
        <div className='topTitle944'>
          <div>
            <span>Date: </span>
            <span>{order.orderDetails.orderDate?.split("T")[0]}</span>
          </div>
          <div>
            <span>Total: </span>
            <span>
              {userCurrency} {order.orderDetails?.totalPricePaid}
            </span>
          </div>
        </div>
        <div className='flexingImageDIv12'>
          <div className='ImageFlexReceorderDIv4'>
            {order.products?.slice(0, 3).map((item) => {
              return (
                <div>
                  <img
                    loading='lazy'
                    className='ImageFlexReceorderDIv4img'
                    src={
                      item?.productImage[0]
                        ? `${item?.productImage[0].split("/upload/")[0]}/upload/f_auto,q_auto,w_50/${item?.productImage[0].split("/upload/")[1]}`
                        : ""
                    }
                  />
                </div>
              );
            })}
          </div>
          {order.products.lenght > 3 && <div>+ {order.products.lenght - 3}</div>}
        </div>
        {newOrder && <div className='newReceivedOrder12'>new</div>}
      </div>
    </>
  );
};

export default EachReceiveOder;
